import { useMemo } from 'react';
import { I18n } from '~/common/explicit-exports';
import { FilterButton } from '~/features/common';
import { useSearch } from '../../providers';
import { UpdateDate } from '../../types';

export const AdvancedSearchResetFilterButton = ({ onOpen }) => {
  const FILTER = I18n.t('js.learner.advanced_search.filters.title');

  const {
    contentTypes,
    setContentTypes,
    contentSources,
    setContentSources,
    filterUpdatedDate,
    updateFilterUpdatedDate,
    selectedTags,
    setSelectedTags,
    selectedSkills,
    setSelectedSkills,
  } = useSearch();

  const filterCount = useMemo(() => {
    let count = 0;
    if (contentTypes.length) {
      count += contentTypes.length;
    }
    if (contentSources.length) {
      count += contentSources.length;
    }
    if (selectedTags.length) {
      count += selectedTags.length;
    }
    if (filterUpdatedDate !== UpdateDate.ALL_TIME) {
      count += 1;
    }
    if (selectedSkills.length) {
      count += selectedSkills.length;
    }
    return count;
  }, [contentSources, contentTypes, selectedTags, filterUpdatedDate, selectedSkills]);

  return (
    <FilterButton
      label={FILTER}
      filterCount={filterCount}
      onOpen={onOpen}
      onReset={() => {
        setContentTypes([]);
        setContentSources([]);
        setSelectedTags([]);
        setSelectedSkills([]);
        updateFilterUpdatedDate(UpdateDate.ALL_TIME);
      }}
    />
  );
};
